<template>
  <div class="index">
    <div class="header" :style="'background: url('+ img+')'">
      <div class="top">
        <div class="title">
<!--          <img src="@/assets/imgs/logo.png" alt="">-->
          <label>数据大屏</label>
        </div>
        <div class="right-menu">
          <el-button class="taggleUser" size="mini" @click="taggleUser">管理端</el-button>
          <el-dropdown class="avatar-container right-menu-item hover-effect" placement="bottom" trigger="click">
            <div class="avatar-wrapper">
              <span class="name">{{userinfo.realName}}</span>
              <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
              <i class="el-icon-arrow-down" style="font-size: 12px;" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <!-- <router-link @click.native="changepassword">
                <el-dropdown-item>修改密码</el-dropdown-item>
              </router-link> -->
              <el-dropdown-item @click.native="logout">
                <span style="display:block;">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <el-scrollbar class="main">
      <Grdp/>
    </el-scrollbar>
  </div>
</template>
<script>
import {getLoginUserInfo} from '@/page/system/api/user';
import Grdp from './index.vue';
export default {
  name: "index",
  components: {
    Grdp
  },
  data () {
    return {
      img: require('@/assets/imgs/headerbg1.png'),
      changepwd: false,
      userinfo: {},
    }
  },
  mounted () {
    this.getuserinfo()
    // this.$notify({
    //   dangerouslyUseHTMLString: true,
    //   title: '可视化数据大屏（演示环境-请勿放生产数据）',
    //   message: `点击购买`,
    //   duration: 0,
    //   onClick: () => {
    //     window.open('https://avuejs.com/views/pay/')
    //   }
    // });
  },
  methods: {
    getuserinfo(){
      getLoginUserInfo().then(res => {
        console.log('res.data', res.data)
        if(res.data.success) {
          this.userinfo = res.data.data
        }
      })
    },

    taggleUser() {
      this.$router.push('/')
    },
    changepassword() {
      this.changepwd = true
    },
    logout() {
      console.log('退出登录')
      localStorage.removeItem('daping_token')
      // sessionStorage.removeItem('daping_token')
      console.log('this', this.$router)
      this.$router.push({name:'/'})
    }
  }
}
</script>
<style lang="scss">
.index {
  height: 100%;
  .header {
    height: 157px;
    position: relative;

    .top {
      padding: 28px 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        display: flex;
        justify-items: center;
        align-items: center;
        span {
          height: 44px;
          width: 0px;
          display: inline-block;
          border: 1px solid #fff;
          margin: 0 19px;
          vertical-align: middle;
        }
        label {
          font-size: 36px;
          color:#fff;
          &::before {
            content: '';
            display: inline-block;
            width: 1px;
            height: 44px;
            vertical-align: middle;
            margin: 0 20px;
            background: #fff;
          }
        }
      }
    }
    .nav {
      margin: 0 20px;
      width: 100%;
      position: absolute;
      bottom: 10px;
      border: none;
      .el-menu-item {
        background-color: rgba(0, 0, 0, 0) !important;
      }
    }
    .title small {
      font-size: 18px;
      color: #9cb4c2;
    }
    .right-menu {
      // position: absolute;
      height: 33px;
      border-radius: 10px;
      // background: #F6F9FD;
      display: flex;
      &:hover {
        // background: #F6F9FD;
        border-radius: 10px;
      }
      &:focus {
        outline: none;
      }
      .taggleUser {
        margin-right: 10px;
        color: #fff;
        background: transparent;
        border: 0;
        &:hover {
          background: rgba(0, 0, 0, 0.25);
        }
      }
      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #fff;
        background: transparent;
        border-radius: 5px;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;
        }
      }

      .avatar-container {
        // margin-right: 20px;
        .avatar-wrapper {
          position: relative;
          vertical-align: middle;
          // padding:0 20px;
          .name {
            display: inline-block;
            font-size: 14px;
            line-height: 33px;
          }
          .user-avatar {
            cursor: pointer;
            width: 30px;
            height: 30px;
            border-radius: 15px;
            margin-right: 5px;
            vertical-align: middle;
          }
          span {
            vertical-align: middle;
          }
          .el-icon {
            vertical-align: middle;
          }
          .el-icon-caret-bottom {
            cursor: pointer;
            // position: absolute;
            right: -20px;
            top: 12px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .main {
    width: 99.7%;
    margin:5px;
    height: calc(100% - 160px);
  }
}

.el-dropdown-menu {
  border: 0;
  background: rgba(0, 0, 0, 0.25);
  &.el-popper {
    .popper__arrow {
      border-bottom-color: rgba(0, 0, 0, 0.25);
      &::after {
        border-bottom-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
  .el-dropdown-menu__item {
    color: #7F8EB6;
  }
  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background: transparent;
    color: #fff;
  }

}
</style>
